import { Component } from '@angular/core';

@Component({
    selector: 'app-forbidden',
    imports: [],
    templateUrl: './forbidden.component.html',
    styles: ``
})
export class ForbiddenComponent {

}
